import { View } from '@react-pdf/renderer';

import { Table } from '../../../components/PdfExportV2/Table/Table.tsx';
import { Td } from '../../../components/PdfExportV2/Td/Td.tsx';
import { Text } from '../../../components/PdfExportV2/Text/Text.tsx';
import { Th } from '../../../components/PdfExportV2/Th/Th.tsx';
import { Tr } from '../../../components/PdfExportV2/Tr/Tr.tsx';
import { BORDER, TABLE_CONFIGS } from './consts.ts';
import { TableConfigKey } from './types.ts';

const getColumnWidth = (columnWidths: number[], index: number) => ({
  width: columnWidths[index] ? `${columnWidths[index]}%` : '100%',
});

export const ExportCommentaryTable = ({
  data: [firstRow, ...rest],
  configKey,
  helperText,
  hideInnerContentBorders = false,
}: {
  data: [string[], ...Array<string | string[]>[]];
  configKey?: TableConfigKey;
  helperText?: string;
  hideInnerContentBorders?: boolean;
}) => {
  const { columnWidths } = configKey ? TABLE_CONFIGS[configKey] : { columnWidths: [] };

  return (
    <View wrap={false}>
      <Table>
        <Tr>
          {firstRow.map((header, index) => (
            <Th
              key={header}
              style={{
                ...getColumnWidth(columnWidths, index),
                borderLeft: index === 0 ? BORDER : 'none',
                borderRight: (index === firstRow.length - 1 || index === 0) ? BORDER : 'none',
                borderBottom: BORDER,
                borderTop: BORDER,
              }}
            >
              {header}
            </Th>
          ))}
        </Tr>
        {rest.map((row) => (
          <Tr key={row.toString()}>
            {row.map((cell, cellIndex) => (
              <Td
                key={cell.toString()}
                style={{
                  ...getColumnWidth(columnWidths, cellIndex),
                  borderRight: (() => {
                    if (cellIndex === row.length - 1 || cellIndex === 0) {
                      return BORDER;
                    }
                    if (hideInnerContentBorders) {
                      return 'none';
                    }
                    return BORDER;
                  })(),
                }}
                isFirstColumn={cellIndex === 0}
              >
                {Array.isArray(cell) ? (
                  cell.map((c) => (
                    <View style={{ display: 'flex', flexDirection: 'column' }} key={c}>
                      <Text variant="td">{c}</Text>
                    </View>
                  ))
                ) : (
                  <Text variant="td">{cell}</Text>
                )}
              </Td>
            ))}
          </Tr>
        ))}
      </Table>
      {helperText && <Text variant="tableHelperText">{helperText}</Text>}
    </View>
  );
};
